module.exports = __webpack_public_path__ + "img/Home Icon - charcoal.98f13486.svg";